<template>
  <v-autocomplete
      :key="currentCountry?.id"
      v-model="currentCountry"
      :hide-details="true"
      :items="decathStore.countries"
      :placeholder="t('placeholder')"
      data-cy="country-selector"
      item-title="name"
      item-value="code"
      :multiple="multiple"
      :menu-props="{closeOnContentClick :false}"
      clear-on-select
      return-object
      append-inner-icon="mdi-magnify"
      menu-icon=""
      variant="outlined"
      :chips="withChips"
      :closable-chips="withChips"
      density="compact"
      color="primary">

    <template #item="{item, props}">
      <v-list-item v-bind="props" :title="item?.raw?.name" density="compact">
        <template #prepend>
          <country-flag :country="item?.raw?.id" class="mb-0 mr-0"/>
        </template>
      </v-list-item>
    </template>

    <template v-if="withChips" v-slot:chip="{ props, item, index}">
      <v-chip color="primary"
              v-bind="props"
              class="text-body-1" :closable="index!==0">
        <template #prepend>
          <CountryFlag size="normal" :country="item?.raw?.id" class="mb-0"/>
        </template>
        <span class="ml-1">
          {{ useCapitalize(item?.raw?.name) }}
          </span>
      </v-chip>
    </template>

    <template #selection="{item}">
      <v-sheet class="d-flex align-center">
        <CountryFlag :country="item?.raw?.id" class="mb-0"/>
        <v-chip variant="text" class="text-body-1">{{ item?.raw?.name }}</v-chip>
      </v-sheet>
    </template>

  </v-autocomplete>
</template>
<script lang="ts" setup>
import type {Country} from "~/types/countries"
import {useI18n} from "vue-i18n";

const {t} = useI18n()
const currentCountry = defineModel<Country | Country[]>()
const decathStore = useDecathlonStores()

useAsyncData(() => decathStore.fetchCountries())

defineProps<{
  multiple: boolean
  withChips: boolean
  firstChipsClosable?: boolean
}>()

</script>
<i18n>
fr:
  placeholder: Choisir un pays
en:
  placeholder: Choose your country
</i18n>
<style scoped>
.normal-flag {
  transform: scale(0.37);
}
</style>
